import React from 'react'
import { Box, Alert, Button } from '@mui/material'

import { authedAxios } from './utils'

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      hasError: false,
    }
  }

  componentDidCatch(error) {
    const { message, stack } = error

    console.log(message)

    authedAxios
      .post('/api/client-logs', {
        message,
        stack,
        path: window.location.pathname,
      })
      .catch(() => {})
  }

  static getDerivedStateFromError(error) {
    return { hasError: true }
  }

  render() {
    if (this.state.hasError)
      return (
        <Box
          sx={{
            margin: 1,
            height: 'calc(100vh - 16px)',
            width: 'calc(100vw - 16px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column',
          }}
        >
          <Box
            sx={{
              display: 'flex',

              justifyContent: 'center',
              flexDirection: 'column',
            }}
          >
            <Alert severity='error' sx={{ mb: 1 }}>
              Something went really wrong on our end. Don't worry! If you're
              seeing this message, we've already been informed of the problem.
            </Alert>
            <Alert
              severity='info'
              action={
                <Button onClick={() => window.location.replace('/')}>
                  Back to safety
                </Button>
              }
            >
              In the meantime, try refreshing the page. If that doesn't resolve
              the issue, please come back later
            </Alert>
          </Box>
        </Box>
      )
    return this.props.children
  }
}
